import { Link } from "react-router-dom";
import { PERSONALITIES } from "../data/site";
import Reveal from "./Reveal";
import { Flower, Frog, Butterfly, MusicNote } from "./Doodles";
import { Star, Cloud } from "./Illustrations";
import { PrimaryDoodle } from "./PersonalityDoodles";

const BG = {
  "sunshine-chasers": "#F4C734",
  "non-stop-runners": "#EE8C72",
  "tiny-trendsetters": "#C6B9D6",
  "dreamy-wanderers": "#A9CDE5",
  "fearless-tryers": "#F0A8C3",
  "high-energy-kids": "#DD2E20",
  "friendly-explorers": "#8BC547",
};
const INK = {
  "sunshine-chasers": "#2C2C2A",
  "non-stop-runners": "#2C2C2A",
  "tiny-trendsetters": "#2C2C2A",
  "dreamy-wanderers": "#2C2C2A",
  "fearless-tryers": "#2C2C2A",
  "high-energy-kids": "#FAFAF7",
  "friendly-explorers": "#2C2C2A",
};

const HERO_IMG = {
  "sunshine-chasers": "/products/sol-kid.jpg",
  "non-stop-runners": "/products/rio-kid.jpg",
  "tiny-trendsetters": "/products/chica-kid.jpg",
  "dreamy-wanderers": "/products/luna-kid.jpg",
  "fearless-tryers": "/products/tico-kid.jpg",
  "high-energy-kids": "/products/viva-kid.jpg",
  "friendly-explorers": "/products/mimi-kid.jpg",
};

export default function PersonalityGrid() {
  return (
    <section className="relative py-16 md:py-24 px-5 md:px-10 bg-[#FAFAF7] overflow-hidden" data-testid="personality-grid">
      {/* Decorative doodles */}
      <Flower size={56} className="absolute top-20 right-[6%] wiggle hidden md:block" color="#F0A8C3" center="#F4C734" />
      <Frog size={64} className="absolute bottom-12 left-[4%] wiggle hidden md:block" />
      <Butterfly size={70} className="absolute top-1/3 right-[2%] float-slow hidden lg:block" />
      <MusicNote size={42} className="absolute bottom-20 right-[12%] float-med hidden md:block" />
      <Star size={22} className="absolute top-32 left-[10%] wiggle" color="#DD2E20" />
      <Cloud size={70} className="absolute top-1/2 left-[1%] hidden lg:block opacity-80" />

      <div className="relative mx-auto max-w-[1440px]">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-5 mb-8 md:mb-12">
          <Reveal>
            <div>
              <p className="eyebrow mb-3">Shop by personality</p>
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-[-0.025em] max-w-[18ch]">
                Pick one. <span className="italic" style={{ color: "#DD2E20" }}>Or a few.</span>
              </h2>
            </div>
          </Reveal>
          <Reveal delay={80}>
            <p className="text-[#595955] max-w-[34ch] text-sm md:text-base">
              For all the little versions of them. Some run. Some lead. Some dream. Some explore.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-4 md:gap-5 auto-rows-fr">
          {PERSONALITIES.map((p, i) => {
            // Bento layout: alternate sizes
            const span =
              i === 0 ? "lg:col-span-7" :
              i === 1 ? "lg:col-span-5" :
              i === 2 ? "lg:col-span-4" :
              i === 3 ? "lg:col-span-4" :
              i === 4 ? "lg:col-span-4" :
              i === 5 ? "lg:col-span-6" :
                        "lg:col-span-6";
            return (
              <Reveal key={p.slug} delay={i * 60} className={span}>
                <Link
                  to={`/personality/${p.slug}`}
                  className="group block h-full rounded-[24px] p-6 md:p-7 relative overflow-hidden tilt lift min-h-[230px] md:min-h-[280px]"
                  style={{ background: BG[p.slug], color: INK[p.slug] }}
                  data-testid={`personality-card-${p.slug}`}
                  data-hover="true"
                >
                  <div className="relative z-10 flex flex-col justify-between h-full">
                    <div>
                      <PrimaryDoodle personality={p.slug} className="!w-12 !h-12 mb-3" />
                      <h3 className="font-serif text-3xl md:text-4xl lg:text-5xl leading-[1] tracking-[-0.02em]">
                        {p.title}
                      </h3>
                      <p className="mt-3 text-[15px] md:text-base opacity-75 max-w-[22ch]">{p.line}</p>
                    </div>
                    <div className="flex items-center justify-between mt-6">
                      <span className="text-[12px] font-medium uppercase tracking-[0.2em] opacity-70">{p.collections.length} frame{p.collections.length > 1 ? "s" : ""}</span>
                      <span className="inline-flex w-9 h-9 rounded-full bg-[#2C2C2A] text-[#FAFAF7] items-center justify-center group-hover:rotate-45 transition-transform duration-500">↗</span>
                    </div>
                  </div>

                  {/* Background image bleeding from right */}
                  <div className="absolute right-[-15%] top-[8%] w-[55%] aspect-square opacity-95 hidden sm:block">
                    <img src={HERO_IMG[p.slug]} alt="" className="w-full h-full object-cover rounded-[24px] rotate-[6deg] group-hover:rotate-[3deg] transition-transform duration-700 shadow-[0_20px_40px_rgba(0,0,0,0.18)]" />
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
